import customAxios from '../../customAxios';
import { ADMIN_ACCEPT_MANY_WITHDRAWAL_COMPANIES } from '../../routes';

const acceptManyPay2Company = async (ids: Array<string>): Promise<any> => {
  try {return (await customAxios.put(ADMIN_ACCEPT_MANY_WITHDRAWAL_COMPANIES, {withdrawalsId: ids})).data;
  } catch (error: unknown) {return console.error({ADMIN_ACCEPT_MANY_WITHDRAWAL_COMPANIES: error});}
};

export default acceptManyPay2Company;
